<div class="simulation-table">
  <!-- Status Row -->
  <div class="table-row">
    <div class="table-cell table-label"></div>
    @for (direction of directions; track direction) {
      <div class="table-cell text-center">
        <span class="direction-label">{{ direction.toUpperCase() }}:&nbsp;</span>
        @if (getResultByDirection(direction)) {
          <mat-chip
            [ngClass]="getStatusClass(getResultByDirection(direction)?.status ?? '')"
            class="direction-status"
            >
            {{ getResultByDirection(direction)?.status ?? '—' }}
          </mat-chip>
        } @else {
          <mat-chip class="direction-status status-not-started">—</mat-chip>
        }
      </div>
    }
  </div>

  <!-- Start Time Row -->
  <div class="table-row">
    <div class="table-cell table-label">Start Time</div>
    @for (direction of directions; track direction) {
      <div class="table-cell text-center">
        {{ formatDateTime(getResultByDirection(direction)?.startedAt ?? null) }}
      </div>
    }
  </div>

  <!-- End Time Row -->
  <div class="table-row">
    <div class="table-cell table-label">End Time</div>
    @for (direction of directions; track direction) {
      <div class="table-cell text-center">
        {{ formatDateTime(getResultByDirection(direction)?.completedAt ?? null) }}
      </div>
    }
  </div>

  <!-- Duration Row -->
  <div class="table-row">
    <div class="table-cell table-label">Duration</div>
    @for (direction of directions; track direction) {
      <div class="table-cell text-center">
        {{ calculateDuration(getResultByDirection(direction)?.startedAt ?? null, getResultByDirection(direction)?.completedAt ?? null) }}
      </div>
    }
  </div>
</div>
